import { defineDocument } from '../../schema';
export const blogPartyGameStreamingByTheNumbersMarch2026Document = defineDocument({
    id: 'blog:party-game-streaming-by-the-numbers-march-2026',
    kind: 'blog',
    slug: 'party-game-streaming-by-the-numbers-march-2026',
    route: '/blog/party-game-streaming-by-the-numbers-march-2026',
    seo: {
        title: 'Party Game Streaming by the Numbers: March 2026',
        description: 'Super Battle Golf proved its breakout was real, KaraCorvus took the streamer crown, and March brought more global crossover moments',
        imageAsset: 'twitchStats202603',
    },
    hero: {
        eyebrow: [
            {
                type: 'text',
                text: 'Airhead Blog',
            },
        ],
        title: [
            {
                type: 'text',
                text: 'Party Game Streaming by the Numbers: March 2026',
            },
        ],
        description: [
            {
                type: 'text',
                text: 'Super Battle Golf proved its breakout was real, KaraCorvus took the streamer crown, and March brought more global crossover moments',
            },
        ],
        imageAsset: 'twitchStats202603',
        imageAlt: 'Dynamic collage of top games and streamers for March 2026',
        showDescription: true,
        background: 'blurred-image',
    },
    meta: {
        author: 'Jay',
        publishedAt: new Date('2026-04-04T00:00:00.000Z'),
        updatedAt: new Date('2026-04-04T00:00:00.000Z'),
        tags: ['party-central'],
    },
    sections: [
        {
            id: 'article',
            blocks: [
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: 'March answered a question February left hanging: which party-game stories were real momentum, and which were just a hot start? The ',
                        },
                        {
                            type: 'link',
                            href: '/party-central/reports/2026-03-top-party-games-and-streamers',
                            children: [
                                {
                                    type: 'text',
                                    text: 'full March 2026 report',
                                },
                            ],
                        },
                        {
                            type: 'text',
                            text: ' gives us a full-month view across more than 203,000 observed streams, 81,412 streamers, and 35 languages, and the clearest takeaway is that a few games and creators are starting to separate themselves from the pack.',
                        },
                    ],
                },
            ],
            sections: [
                {
                    id: 'article__the-breakout-that-held-up',
                    title: [
                        {
                            type: 'text',
                            text: 'The Breakout That Held Up',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'February made ',
                                },
                                {
                                    type: 'em',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Super Battle Golf',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: " look like the month's breakout. March made that look less like a lucky launch window and more like the start of a real run. It finished with the widest streamer base in the entire report, showing that its early buzz carried into broad creator adoption instead of fading after release week.",
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'At the top of the rankings, ',
                                },
                                {
                                    type: 'em',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Diablo II: Resurrected',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' held its place because people kept coming back to it, while ',
                                },
                                {
                                    type: 'em',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Fall Guys',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' and ',
                                },
                                {
                                    type: 'em',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Mahjong Soul',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: " climbed into the top three. That is what our Party Score is built to catch: not just who got sampled, but which games actually became part of streamers' routines. It is also why a giant like ",
                                },
                                {
                                    type: 'em',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Among Us',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' could still be near the top by raw stream count and yet miss the top 15 Party Score table entirely.',
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'article__a-tale-of-two-streamers',
                    title: [
                        {
                            type: 'text',
                            text: 'A Tale of Two Streamers',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'link',
                                    href: 'https://twitch.tv/karacorvus',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'KaraCorvus',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' took over the #1 streamer spot in March, which fits the kind of creator this report tends to reward most: someone who shows up consistently, brings a real audience, and covers more than one game. Around her, the streamer leaderboard churned hard from February.',
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'The audience leaderboard told a different story. ',
                                },
                                {
                                    type: 'link',
                                    href: 'https://twitch.tv/caseoh_',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'caseoh_',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: " was still the biggest draw, but March's biggest audience moments were more international and more event-driven than February's. Creators like ",
                                },
                                {
                                    type: 'link',
                                    href: 'https://twitch.tv/theburntpeanut',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'TheBurntPeanut',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ', ',
                                },
                                {
                                    type: 'link',
                                    href: 'https://twitch.tv/tumblurr',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Tumblurr',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ', ',
                                },
                                {
                                    type: 'link',
                                    href: 'https://twitch.tv/kamet0',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Kamet0',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ', and ',
                                },
                                {
                                    type: 'link',
                                    href: 'https://twitch.tv/joueur_du_grenier',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Joueur_du_Grenier',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' all showed how the right party game can turn a single night into a major event, especially when ',
                                },
                                {
                                    type: 'em',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Super Battle Golf',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' is involved.',
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'article__new-games-got-their-chance',
                    title: [
                        {
                            type: 'text',
                            text: 'New Games Got Their Chance',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'March brought a big crop of fresh releases, and a few of them immediately found streamers willing to give them a shot. ',
                                },
                                {
                                    type: 'em',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Poker Night at the Inventory',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: " was the standout debut, helped by the fact that it arrived as a remastered return of Telltale's old cult crossover card game. On its official Steam page, Skunkape pitches the March 5 release as the reopening of the Inventory, with Max, Strong Bad, Tycho, and The Heavy back at the table, which gives the game a built-in nostalgia hook that clearly translated to Twitch. ",
                                },
                                {
                                    type: 'em',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Ham: The Game',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' also got off to a promising start.',
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'article__the-world-map-kept-getting-more-interesting',
                    title: [
                        {
                            type: 'text',
                            text: 'The World Map Kept Getting More Interesting',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'English still dominated party-game streaming by volume, but March once again showed that different language communities pull the category in different directions. Italian posted the highest average viewers per stream, Chinese creators turned ',
                                },
                                {
                                    type: 'em',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Jinsei Game for Nintendo Switch',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' into a late-month collab story, and ',
                                },
                                {
                                    type: 'em',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Fall Guys',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' kept traveling well across Spanish, Portuguese, and Italian channels.',
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'article__read-the-full-march-report',
                    title: [
                        {
                            type: 'text',
                            text: 'Read the Full March Report',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'Read the ',
                                },
                                {
                                    type: 'link',
                                    href: '/party-central/reports/2026-03-top-party-games-and-streamers',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'full March 2026 report',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' for all of the rankings and trends, as well as our breakdown of the best time to stream to maximize your viewership.',
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            id: 'article-actions',
            widgets: [
                {
                    type: 'relatedDocuments',
                    limit: 4,
                },
            ],
        },
    ],
});
//# sourceMappingURL=party-game-streaming-by-the-numbers-march-2026.js.map